import { h } from "preact";
import hawaiiTrees from "../images/hawaii_trees.jpg";
import amalfiBoat from "../images/amalfi_boat.jpg";
import "./corner_styles.css";

const sections = [
  ["Projects", "Things I’ve built because I felt like it.", "/projects"],
  ["Writing", "I write things sometimes. If you like, you could read them sometimes.", "/writing"],
  ["Me", "The less-resume version of me.", "/me"],
  ["Resume", "If you want to get serious about it, check out my full length resume.", "/resume"]
];

export default function CornerHome() {
  return (
    <main class="corner-page home-page">
      <section class="corner-hero" data-scroll-reveal>
        <p class="eyebrow">Celina Ryan</p>
        <h1>A small corner of the internet for things I've built, written, and wanted to remember.</h1>
        <p class="intro">I'm Celina Ryan--a software engineer who enjoys building things, asking questions, and doing a bunch of other stuff. </p>
        <p class="intro">Feel free to check out the rest of this site to learn more about what that "other stuff" entails.</p>
        <a class="text-link" href="/contact">Say hello <span class="link-arrow" aria-hidden="true"></span></a>
      </section>
      <section class="corner-grid" aria-label="Explore this site">
        {sections.map(([title, description, href]) => (
          <a class="corner-card" href={href} key={title} data-scroll-reveal>
            <h2>{title}</h2>
            <p>{description}</p>
            <span class="link-arrow" aria-hidden="true"></span>
          </a>
        ))}
      </section>
      <section class="home-photo-story" aria-label="A glimpse outside the work">
        <figure class="home-photo-panel" data-scroll-photo>
          <img src={hawaiiTrees} alt="Trees in Hawaii" />
          <figcaption>Kauai, HI</figcaption>
        </figure>
        <figure class="home-photo-panel" data-scroll-photo>
          <img src={amalfiBoat} alt="Boat along the Amalfi Coast" />
          <figcaption>Amalfi Coast, Italy</figcaption>
        </figure>
      </section>
    </main>
  );
}
